module.exports = __webpack_public_path__ + "img/avatar-s-4.6a665e7c.jpg";